import {getPopupData, getPopupInstance} from './media';

export default class Tags {
  static CLASSES = {
    HIDDEN: 'hidden',
    ACTIVE: 'tag-active',
    VIDEO_TEMPLATE: 'media-card-video-template',
    IMAGE_TEMPLATE: 'media-card-image-template',
    ARTICLE_TEMPLATE: 'media-card-article-template'
  };

  constructor(endpoint) {
    this.$INPUT = document.querySelector('.tags-select-menu input');
    this.$CHOSEN = document.querySelector('.tags-select-chosen');
    this.$CHOSEN_TITLE = document.querySelector('.tags-select-chosen-title');

    this.$TAGS_WRAPPER = document.querySelector('.tags-select-wrapper--tags');
    this.$TAGS_MAIN = this.$TAGS_WRAPPER.querySelector('.tags-select-menu-main');
    this.$TAGS_ITEMS = this.$TAGS_MAIN.childNodes;
    this.$TAGS_BUTTON = this.$TAGS_WRAPPER.querySelector('.tags-select');

    this.$SORT_WRAPPER = document.querySelector('.tags-select-wrapper--sort');
    this.$SORT_MAIN = this.$SORT_WRAPPER.querySelector('.tags-select-menu-main');
    this.$SORT_ITEMS = this.$SORT_MAIN.childNodes;
    this.$SORT_BUTTON = this.$SORT_WRAPPER.querySelector('.tags-select');

    this.$DEFAULT_CONTAINER = document.querySelector(
      '.press__wrapper--default, .media-page__wrapper--default'
    );
    this.$DEFAULT_CONTAINER_WRAPPER = document.querySelector(
      '.press__wrapper--default .press__wrapper, .media-page__wrapper--default .media-page__wrapper'
    );
    this.$DEFAULT_CONTAINER_LOADING = document.querySelector(
      '.press__wrapper--default .press__action p'
    );
    this.$DEFAULT_CONTAINER_BUTTON = document.querySelector(
      '.press__wrapper--default .press__button'
    );
    this.$TAGS_CONTAINER = document.querySelector(
      '.press__wrapper--tags, .media-page__wrapper--tags'
    );
    this.$TAGS_CONTAINER_WRAPPER = document.querySelector(
      '.press__wrapper--tags .press__wrapper, .media-page__wrapper--tags .media-page__wrapper'
    );
    this.$TAGS_CONTAINER_LOADING = document.querySelector(
      '.press__wrapper--tags .press__action p, .media-page__wrapper--tags .media-page__action p'
    );
    this.$TAGS_CONTAINER_BUTTON = document.querySelector(
      '.press__wrapper--tags .press__button, .media-page__wrapper--tags .media-page__button'
    );

    this.CRITERIA_TIMEOUT = 500;

    this.API_ENDPOINT = endpoint;
    this.API_TAG_PARAM = 'tag';
    this.API_SORT_PARAM = 'sort';

    this.API_TYPE_MEDIA = 'media';
    this.API_TYPE_ARTICLE = 'news';
    this.API_CATEGORY_IMAGE = 'image';
    this.API_CATEGORY_VIDEO = 'video';

    if (endpoint) {
      this.init();
    } else {
      this.init(true);
    }
  }

  toggleTagsMenu = () => {
    this.$TAGS_WRAPPER.classList.toggle('tags-select-wrapper--active');
  };

  toggleSortMenu = () => {
    this.$SORT_WRAPPER.classList.toggle('tags-select-wrapper--active');
  };

  onInputChange = () => {
    const regexp = new RegExp(this.$INPUT.value, 'ig');

    let tags = this.$TAGS_ITEMS;

    tags.forEach((tag) => {
      if (!tag.classList.contains(Tags.CLASSES.ACTIVE)) {
        if (tag.innerText.match(regexp)?.length) {
          tag.classList.remove(Tags.CLASSES.HIDDEN);
        } else {
          tag.classList.add(Tags.CLASSES.HIDDEN);
        }
      }
    });
  };

  showMainTab = () => {
    $(this.$DEFAULT_CONTAINER).fadeIn();
    $(this.$TAGS_CONTAINER).fadeOut();

    this.$TAGS_CONTAINER_WRAPPER.replaceChildren();

    getPopupInstance()?.setData(getPopupData());
    getPopupInstance()?.initItems();
  };

  showTagsTab = () => {
    $(this.$DEFAULT_CONTAINER).fadeOut();
    $(this.$TAGS_CONTAINER).fadeIn();
  };

  toggleLoadingUI = (loading = true, hideWrapper = true) => {
    if (loading) {
      $(this.$TAGS_CONTAINER_LOADING).fadeIn();
      $(this.$TAGS_CONTAINER_BUTTON).fadeOut(0);

      $(this.$DEFAULT_CONTAINER_LOADING).fadeIn();
      $(this.$DEFAULT_CONTAINER_BUTTON).fadeOut(0);

      if (hideWrapper) {
        $(this.$TAGS_CONTAINER_WRAPPER).fadeOut();
      }
    } else {
      $(this.$TAGS_CONTAINER_LOADING).fadeOut();
      $(this.$TAGS_CONTAINER_BUTTON).fadeIn(0);
      $(this.$TAGS_CONTAINER_WRAPPER).fadeIn();

      $(this.$DEFAULT_CONTAINER_LOADING).fadeOut();
      $(this.$DEFAULT_CONTAINER_BUTTON).fadeIn(0);
    }
  };

  handleTagsButtonClick = () => {
    this.$TAGS_CONTAINER_BUTTON.addEventListener('click', () => {
      if (this.$TAGS_MORE_LINK) {
        this.sendQuery(this.$TAGS_MORE_LINK);
      }
    });
  };

  handleDefaultButtonClick = () => {
    this.$DEFAULT_MORE_LINK = this.$DEFAULT_CONTAINER_BUTTON?.dataset.href;

    this.$DEFAULT_CONTAINER_BUTTON?.addEventListener('click', () => {
      if (this.$DEFAULT_MORE_LINK) {
        this.sendQuery(this.$DEFAULT_MORE_LINK, true);
      }
    });
  };

  handleNewsCardTemplate = (data, isDefault) => {
    const template = document.querySelector('.news-card-template').cloneNode(true);

    template.setAttribute('href', data.url);
    template.querySelector('img').setAttribute('src', data.banner.url);
    template.querySelector('.news-card__info-title').textContent = data.title;
    template.querySelector('.news-card__info-date').textContent = data.datetime;

    const tags = template.querySelector('.news-card__tags');

    tags.replaceChildren();

    data.tags.forEach((tag) => {
      const tagTemplate = document
        .querySelector('.news-card-template .news-card__tags-item')
        .cloneNode(true);

      tagTemplate.style.color = tag.color;
      tagTemplate.querySelector('span').textContent = tag.name;

      tags.append(tagTemplate);
    });

    template.classList.remove(Tags.CLASSES.HIDDEN);

    if (!isDefault) {
      this.$TAGS_CONTAINER_WRAPPER.append(template);
    } else {
      this.$DEFAULT_CONTAINER_WRAPPER.append(template);
    }
  };

  handleArticleCardTemplate = (data) => {
    const template = document.querySelector(`.${Tags.CLASSES.ARTICLE_TEMPLATE}`).cloneNode(true);

    template.setAttribute('href', data.url);
    template.querySelector('img')?.setAttribute('src', data.banner.url);
    template.querySelector('.media-card__info-text').textContent = data.title;
    template.querySelector('.media-card__info-date').textContent = data.datetime;

    const tags = template.querySelector('.media-card__tags');

    tags?.replaceChildren();

    data.tags.forEach((tag) => {
      const tagTemplate = document
        .querySelector('.media-card-article-template .media-card__tags-item')
        .cloneNode(true);

      tagTemplate.style.color = tag.color;
      tagTemplate.querySelector('span').textContent = tag.name;

      tags.append(tagTemplate);
    });

    template.classList.remove(Tags.CLASSES.HIDDEN);
    template.classList.remove(Tags.CLASSES.ARTICLE_TEMPLATE);

    this.$TAGS_CONTAINER_WRAPPER.append(template);
  };

  handleImageCardTemplate = (data) => {
    const template = document.querySelector(`.${Tags.CLASSES.IMAGE_TEMPLATE}`).cloneNode(true);

    template.querySelector('img')?.setAttribute('src', data.banner.url);
    template.querySelector('.media-card__info-title').textContent = data.title;
    template.querySelector('.media-card__info-date').textContent = data.datetime;
    template.querySelector('.media-card__image').dataset.srcUrl = data.media.src_url;
    template.querySelector('.media-card__relative').dataset.relative = JSON.stringify(
      data.media?.relatives
    );

    template.classList.remove(Tags.CLASSES.HIDDEN);
    template.classList.remove(Tags.CLASSES.IMAGE_TEMPLATE);

    this.$TAGS_CONTAINER_WRAPPER.append(template);
  };

  handleVideoCardTemplate = (data) => {
    const template = document.querySelector(`.${Tags.CLASSES.VIDEO_TEMPLATE}`).cloneNode(true);

    template.querySelector('img')?.setAttribute('src', data.banner.url);
    template.querySelector('.media-card__info-title').textContent = data.title;
    template.querySelector('.media-card__info-date').textContent = data.datetime;
    template.querySelector('.media-card__image').dataset.videoSrc = data.media.video_src;
    template.querySelector('.media-card__image').dataset.srcUrl = data.media.src_url;
    template.querySelector('.media-card__relative').dataset.relative = JSON.stringify(
      data.media?.relatives
    );

    template.classList.remove(Tags.CLASSES.HIDDEN);
    template.classList.remove(Tags.CLASSES.VIDEO_TEMPLATE);

    this.$TAGS_CONTAINER_WRAPPER.append(template);
  };

  handleMediaCardTemplate = (data) => {
    switch (data.dtype) {
      case this.API_TYPE_ARTICLE: {
        this.handleArticleCardTemplate(data);
        break;
      }

      case this.API_TYPE_MEDIA: {
        switch (data.media?.type) {
          case this.API_CATEGORY_IMAGE: {
            this.handleImageCardTemplate(data);
            break;
          }

          case this.API_CATEGORY_VIDEO: {
            this.handleVideoCardTemplate(data);
            break;
          }
        }
      }
    }
  };

  handleJSONResults = (json, isOuterUrl = false, isDefault = false) => {
    if (!isOuterUrl && !isDefault) {
      this.$TAGS_CONTAINER_WRAPPER.replaceChildren();
    }

    if (!isDefault) {
      this.$TAGS_MORE_LINK = json.next;
    } else {
      this.$DEFAULT_MORE_LINK = json.next;
    }

    json.results.forEach((result) => {
      if (document.querySelector('.press__wrapper--default')) {
        this.handleNewsCardTemplate(result, isDefault);
      } else if (document.querySelector('.media-page__wrapper--default')) {
        this.handleMediaCardTemplate(result);
      }
    });

    getPopupInstance()?.setData(getPopupData(this.$TAGS_CONTAINER_WRAPPER));
    getPopupInstance()?.initItems();

    this.toggleLoadingUI(false);

    if (!json.next) {
      if (!isDefault) {
        $(this.$TAGS_CONTAINER_BUTTON).fadeOut(0);
      } else {
        $(this.$DEFAULT_CONTAINER_BUTTON).fadeIn(0);
      }
    }
  };

  sendQuery = (outerUrl = null, isDefault = false) => {
    if (!isDefault) {
      this.showTagsTab();
    }

    if (outerUrl) {
      this.toggleLoadingUI(true, false);
    } else {
      this.toggleLoadingUI();
    }

    const request = new XMLHttpRequest();

    request.onerror = () => {
      console.log('Internal Server Error');
    };
    request.onload = () => {
      this.handleJSONResults(
        JSON.parse(request.response),
        outerUrl ? true : false,
        isDefault ? true : false
      );
    };

    if (outerUrl) {
      request.open('GET', outerUrl);
    } else {
      const tagParams = [];
      const sortParams = [];

      this.$CHOSEN.childNodes.forEach((tag) => {
        if (tag.dataset.slug != 'undefined') tagParams.push(tag.dataset.slug);
        if (tag.dataset.sort != 'undefined') sortParams.push(tag.dataset.sort);
      });

      const url = new URL(this.API_ENDPOINT);

      tagParams.length && url.searchParams.set(this.API_TAG_PARAM, tagParams.join(','));
      sortParams.length && url.searchParams.set(this.API_SORT_PARAM, sortParams.join(','));

      request.open('GET', url);
    }

    request.send();
  };

  sendQueryTimeout = () => {
    this.QUERY_TIMEOUT = window.setTimeout(this.sendQuery, this.CRITERIA_TIMEOUT);
  };

  clearQueryTimeout = () => {
    window.clearTimeout(this.QUERY_TIMEOUT);
  };

  addChosenTag = (criteria) => {
    this.clearQueryTimeout();

    const chosenTag = Array.from([...this.$TAGS_ITEMS, ...this.$SORT_ITEMS]).filter(
      (tag) => tag.dataset?.slug == criteria || tag.dataset?.sort == criteria
    )[0];
    const chosenTagInfo = {
      color: chosenTag.style.color,
      text: chosenTag.textContent,
      slug: chosenTag.dataset?.slug,
      sort: chosenTag.dataset?.sort
    };
    const tagTemplate = document.querySelector('.tags-select-chosen-template').cloneNode(true);

    tagTemplate.style.color = chosenTagInfo.color;
    tagTemplate.querySelector('span').textContent = chosenTagInfo.text;
    tagTemplate.dataset.slug = chosenTagInfo.slug;
    tagTemplate.dataset.sort = chosenTagInfo.sort;
    tagTemplate.classList.remove(Tags.CLASSES.HIDDEN);
    tagTemplate
      .querySelector('svg')
      .addEventListener('click', () =>
        this.removeChosenTag(chosenTagInfo.slug || chosenTagInfo.sort)
      );

    chosenTag.classList.add(Tags.CLASSES.ACTIVE);

    this.$CHOSEN.append(tagTemplate);
    this.$CHOSEN_TITLE.classList.remove(Tags.CLASSES.HIDDEN);

    this.sendQueryTimeout();
  };

  removeChosenTag = (criteria) => {
    this.clearQueryTimeout();

    const chosenTag = Array.from(this.$CHOSEN.childNodes).filter(
      (chosenTag) => chosenTag.dataset?.slug == criteria || chosenTag.dataset?.sort == criteria
    )[0];
    const initialTag = Array.from([...this.$TAGS_ITEMS, ...this.$SORT_ITEMS]).filter(
      (tag) => tag.dataset?.slug == criteria || tag.dataset?.sort == criteria
    )[0];

    chosenTag.remove();
    initialTag.classList.remove(Tags.CLASSES.ACTIVE);

    if (this.$CHOSEN.childNodes.length <= 0) {
      this.$CHOSEN_TITLE.classList.add(Tags.CLASSES.HIDDEN);
      this.showMainTab();
    } else {
      this.sendQueryTimeout();
    }
  };

  removeAllTags = (tagsOnly = true) => {
    const chosenTags = this.$CHOSEN.childNodes;

    for (let i = chosenTags.length - 1; i >= 0; i--) {
      if (chosenTags[i].dataset?.slug != 'undefined') {
        if (tagsOnly) {
          this.removeChosenTag(chosenTags[i].dataset?.slug);
        }
      } else if (!tagsOnly) {
        this.removeChosenTag(chosenTags[i].dataset?.sort);
      }
    }
  };

  checkLinkParameters = () => {
    const urlParams = new URLSearchParams(window.location.search);

    const tags = urlParams.get('tag')?.split(',') || [];
    const sorts = urlParams.get('sort')?.split(',') || [];

    [...tags, ...sorts].forEach((criteria, index) => {
      if (index === [...tags, ...sorts].length - 1) {
        this.CRITERIA_TIMEOUT = 0;

        this.addChosenTag(criteria);

        setTimeout(() => (this.CRITERIA_TIMEOUT = 500), 500);
      } else this.addChosenTag(criteria);
    });
  };

  init = (partially = false) => {
    this.$TAGS_BUTTON.addEventListener('click', this.toggleTagsMenu);
    this.$SORT_BUTTON.addEventListener('click', this.toggleSortMenu);
    this.$INPUT.addEventListener('keyup', this.onInputChange);

    if (partially) return;

    [...this.$TAGS_ITEMS, ...this.$SORT_ITEMS].forEach((tag) => {
      tag.addEventListener('click', () =>
        this.addChosenTag(tag.dataset?.slug || tag.dataset?.sort)
      );
    });

    this.$TAGS_WRAPPER
      .querySelector('.tags-select-menu-footer p')
      .addEventListener('click', this.removeAllTags);

    this.$SORT_WRAPPER
      .querySelector('.tags-select-menu-footer p')
      .addEventListener('click', () => this.removeAllTags(false));

    this.handleTagsButtonClick();
    this.handleDefaultButtonClick();

    this.checkLinkParameters();
  };
}
